import {
  GET_TECHNICAL_SUITABILITY,
  GET_TECHNICAL_SUITABILITY_ERROR,
  GET_TECHNICAL_SUITABILITY_SUCCESS
} from './TechnicalSuitabilitySection.actions'

const technicalSuitabilityState = {
  activityStartDate: '',
  error: undefined,
  loading: true
}

/**
 * The Technical Suitability Section reducer.
 */
const technicalSuitabilityReducer = (state = technicalSuitabilityState, { payload, type }) => {
  switch (type) {
    case GET_TECHNICAL_SUITABILITY: {
      return { ...state, loading: true }
    }
    case GET_TECHNICAL_SUITABILITY_SUCCESS: {
      return {
        ...state,
        loading: false,
        activityStartDate: payload.activityStartDate
      }
    }
    case GET_TECHNICAL_SUITABILITY_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default technicalSuitabilityReducer
